import React from 'react';
import FeatherIcon from 'src/components/10-atoms/icons/FeatherIcon';
import { createTabScreen } from 'src/navigation/primaryNav/createTabScreen';
import { RootTab } from 'src/navigation/TabNavigation';
import withSuspense from 'src/navigation/withSuspense';
const Home = withSuspense(React.lazy(() => import('./screens/Home')));
export const examPrepNavEntry = {
    id: 'ep',
    prefix: 'EP_',
    to: { screen: 'EP_Home', params: {} },
    label: ({ translate }) => translate('Exams'),
    renderIcon: (color, size) => (React.createElement(FeatherIcon, { name: "edit-3", color: color, size: size })),
    isVisible: () => true,
    placements: ['tab', 'sidebar-main'],
    renderTabRoutes(ctx) {
        return (React.createElement(RootTab.Group, null, createTabScreen(examPrepNavEntry, ctx, 'EP_Home', Home)));
    },
};
export function renderExamPreparationTabRoutes(ctx) {
    return examPrepNavEntry.renderTabRoutes(ctx);
}
